$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-kielipalvelut/"
    };

    $("#simultaneousOrderForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#simultaneousOrderForm')[0].checkValidity()) {
            $("#simultaneousSendBtn").prop("disabled", true);
            $("#simultaneousSendBtn").css("background-color", "#6c757d");

            let email = $("#simultaneousEmail").val();
            let firstName = $("#simultaneousFirstName").val();
            let lastName = $("#simultaneousLastName").val();
            let phone = $("#simultaneousPhoneNumber").val();
            let sourceLang = $("#simultaneousSourceLanguages").val();
            let targetLang = $("#simultaneousTargetLanguages").val();
            let message = $("#simultaneousMessage").val();
            let organization = $("#simultaneousOrganization").val();

            let fullAdditionalInformation = `Lähtökieli: ${sourceLang}\nKohdekieli: ${targetLang}\n\nViesti: ${message}`;

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: fullAdditionalInformation,
                phoneNumber: phone,
                organizationName: organization,
                competitionName: "Simultaanitulkkaus",
                uri: "/fi/simultaanitulkkaus",
                languageCode: language,
                code: "",
            };

            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#simultaneousSendBtn").prop("disabled", false);
                    $("#simultaneousSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    function toggleSendButtonState() {
        const formValid = $('#simultaneousOrderForm')[0].checkValidity();
        if (formValid) {
            $("#simultaneousSendBtn").prop("disabled", false);
            $("#simultaneousSendBtn").css("background-color", "#28a745");
        } else {
            $("#simultaneousSendBtn").prop("disabled", true);
            $("#simultaneousSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    $('#simultaneousOrderForm input, #simultaneousOrderForm textarea').on('input change', toggleSendButtonState);
    toggleSendButtonState();
});
